module.exports = __webpack_public_path__ + "static/media/frog_specification.d537b01f.md";